import { TourSaleLiteModel } from 'api-hooks/tour/tour-sale';
import { NavigationRoutes } from 'common/constants';
import { PaginationMeta } from 'common/repositories/common.model';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import { TableContainer } from 'components/styles';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import * as React from 'react';
interface Props {
  tourSales: TourSaleLiteModel[];
  loading?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  meta?: PaginationMeta;
  sortColumns: IColumn<any>[];
}

export default function ToursaleTable(props: Props) {
  const { tourSales, sortColumns, loading, page, onPageChange, meta } = props;
  const permissions = useGetCrudPermission('tour-sales');
  const { navigate } = useNavigation();

  const onItemInvoked = ({ original }) => {
    navigate(NavigationRoutes.ToursalesView, {
      id: original.id,
    });
  };

  const columns = React.useMemo<IColumn<any>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        stickyLeft: true,
        minSize: 40,
        maxSize: 40,
        cell: ({ row }) => {
          return (
            <>
              {row.index +
                1 +
                ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
            </>
          );
        },
      },
      ...sortColumns,
    ],
    [meta?.currentPage, meta?.perPage, sortColumns],
  );

  return (
    <>
      <TableContainer>
        <TableComponent
          columns={columns}
          isLoading={loading}
          data={tourSales || []}
          onOpenDetail={onItemInvoked}
          rowLink={(row) => {
            if (!permissions.view) return undefined;
            return {
              pathname: NavigationRoutes.ToursalesView,
              query: {
                id: row.original.id,
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={onPageChange}
        meta={meta}
      />
    </>
  );
}
